module.exports = __webpack_public_path__ + "img/logo.2098984a.webp";